import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Box, Button, Card, CardContent, TextField } from '../../../../components/mui/Core/index'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import { resendInviteFormConstants } from '../../../../constants/resend-invite-constants'
import { resendInvite } from '../../../../api/user/resend-invite'
import GenericSnackbar from '../../../../components/GenericSnackbar/generic-snackbar'
import { setSnackbar } from '../../../../components/GenericSnackbar/generic-snackbar-slice'

function ResendPassword() {
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [signUpEmail, setSignUpEmail] = useState('')

  const handleEmailChange = (event) => {
    setSignUpEmail(event.target.value)
  }

  const handleResendPassword = () => {
    const request = {
      requestBody: {
        email: signUpEmail,
      },
    }
    resendInvite(request)
      .then(() => {
        navigate('/resend-password/success')
      })
      .catch((exception) => {
        dispatch(
          setSnackbar({
            message: exception?.message,
            severity: 'error',
            action: true,
          }),
        )
      })
  }

  const cardContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const sendNewPasswordButtonStyle = { mt: 3 }

  return (
    <>
      <Box sx={theme.soloContainer}>
        <Card className='soloCard'>
          <CardContent sx={cardContentStyle}>
            <FormHeading formHeader={resendInviteFormConstants.HEADING} />
            <TextField
              id='resend-password-email-field'
              value={signUpEmail}
              onChange={handleEmailChange}
              required
              label='Email'
              variant='outlined'
              type='email'
              sx={{ width: '240px' }}
            />
            <Button
              onClick={handleResendPassword}
              variant='contained'
              sx={sendNewPasswordButtonStyle}
              disabled={!signUpEmail}
            >
              {resendInviteFormConstants.SEND_NEW_PW_BUTTON}
            </Button>
          </CardContent>
        </Card>
      </Box>
      <GenericSnackbar />
    </>
  )
}

export default ResendPassword
